<template>
  <div class="container-content">
    <div class="tile-content-header">
      <h3>
        {{ $t('invoices.tracking.title') }}
      </h3>
      <small class="text-uppercase"><b-icon-hash /> {{ containerId }}</small>
    </div>
    <template v-if="container !== null && container !== ''">
      <div class="tile-content-body">
        <status :cc="cc" :cs="cs" />
      </div>
      <!--Link for Modal -->
      <footer class="tile-footer mt-3">
        <small>
          <b-link
            v-b-modal="containerId"
            class="nav-link p-0 d-flex align-items-center justify-content-center"
            v-track-click
            :id="`Container-Tracking`"
            :data-value="containerId"
            ><b-icon-fullscreen
          /></b-link>
        </small>
      </footer>
    </template>
    <div class="no-data" v-else-if="container === ''">
      <loader :height="200" />{{ $t('invoices.tracking.container.fetch') }}
    </div>
    <div class="data-fetch" v-else>
      {{ $t('invoices.tracking.container.noData') }}
    </div>
  </div>
</template>

<script>
import Status from '@/components/invoices/Details/Containers/trackingV2/Status/'
import Loader from '@/components/common/Loader/'
import platformService from '@/services/platform'

export default {
  data() {
    return {
      container: '',
      cc: {},
      cs: 1
    }
  },
  props: ['containerId', 'invoiceShippingData', 'token'],
  computed: {
    getInvoiceAuthToken() {
      return !this.$store.state.account.accountId
        ? this.$route.params.auth_token
        : ''
    }
  },
  methods: {
    getContainer() {
      platformService
        .fetchContainerByInvoice(
          this.containerId,
          this.$route.params.id,
          this.getInvoiceAuthToken,
          this.token
        )
        .then((res) => {
          if (JSON.parse(res.data.events).length > 1) {
            this.container = res.data
            this.$emit('containersLoaded', res.data)
            this.prettyData()
          } else {
            this.container = null
            this.$emit('containersLoaded', null)
          }
        })
    },
    prettyData() {
      this.cc = {
        arrival: {
          location:
            this.container.discharge_port !== null
              ? this.container.discharge_port.split(',')[0].split('(')[0].trim()
              : this.invoiceShippingData.port_of_discharge !== null
              ? this.invoiceShippingData.port_of_discharge
              : (this.container = null),
          time:
            this.container.actual_arrival_at_discharge ||
            this.container.expected_arrival_at_discharge
        },
        departure: {
          location:
            this.container.loading_port !== null
              ? this.container.loading_port.split(',')[0].split('(')[0].trim()
              : this.invoiceShippingData.shipping_port !== null
              ? this.invoiceShippingData.shipping_port
              : (this.container = null),
          time:
            this.container.actual_arrival_at_loading ||
            this.container.expected_arrival_at_loading ||
            this.container.actual_departure_at_loading ||
            this.container.actual_departure_at_loading ||
            this.container.expected_departure_at_loading
        },
        current: {
          location:
            this.container &&
            this.container.current_location &&
            this.container.current_location.split(',')[0].split('(')[0].trim(),
          time: this.container.current_location_time
        }
      }
      this.currentState()
    },
    currentState() {
      if (
        this.cc.current.location === this.cc.arrival.location &&
        this.cc.current.location !== null
      ) {
        this.cs = 3
      } else if (
        this.cc.current.location === this.cc.departure.location &&
        this.cc.current.location !== null
      ) {
        this.cs = 1
      } else {
        this.cs = 2
      }
    }
  },
  created() {
    this.getContainer()
  },
  components: {
    Status,
    Loader
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../../assets/scss/variables';
.container-content {
  position: relative;
  height: 100%;
  .tile-content-header {
    padding: 1rem 2rem;
    background: $dc-actions-bg;
    border-bottom: 1px solid $drip-border-color;
    h3 {
      letter-spacing: 0.6px;
      text-transform: uppercase;
      font-weight: bold;
      color: $dc-input-color;
      font-size: 1rem;
      line-height: 1.5;
    }
  }
  .tile-content-body {
    padding: 1rem 1.5rem;
  }
  .tile-footer {
    position: absolute;
    right: 0;
    font-size: 35px;
    top: 0;
    a {
      background: $light-background-color;
      height: 3rem;
      width: 3rem;
      border-radius: 50%;
      color: $dc-svg;
      margin: 0 1rem;
      transition: all 0.2s;
      span {
        margin-top: -9px;
      }
      &:hover {
        background: $secondary;
        color: white;
      }
    }
  }
  .no-data,
  .data-fetch {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 50%;
  }
}
</style>
